export type NotificationType = {
  id: number
  title: string
  status: 'new' | 'viewed'
  image?: string
  time: string
  content: string
  type: 'system' | 'account'
}

export const notificationsData: NotificationType[] = [
  {
    id: 1,
    title: 'maintenance',
    status: 'new',
    image: '/assets/notifications.png',
    time: '3h ago',
    content: `We would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino. This is we would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino`,
    type: 'system',
  },
  {
    id: 2,
    title: 'maintenance',
    status: 'new',
    image: '/assets/notifications.png',
    time: '3h ago',
    content: `We would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino. This is we would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino`,
    type: 'system',
  },
  {
    id: 3,
    title: 'maintenance',
    status: 'new',
    image: '/assets/notifications.png',
    time: '3h ago',
    content: `We would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino. This is we would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino`,
    type: 'account',
  },
  {
    id: 4,
    title: 'maintenance',
    status: 'viewed',
    time: '3h ago',
    content: `We would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino. This is we would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino`,
    type: 'system',
  },
  {
    id: 5,
    title: 'control',
    status: 'viewed',
    time: '3h ago',
    content: `We would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino. This is we would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino`,
    type: 'account',
  },
  {
    id: 6,
    title: 'control',
    status: 'viewed',
    image: '/assets/notifications.png',
    time: '3h ago',
    content: `We would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino. This is we would like to inform you about a scheduled technical maintenance for Pragmatic Play's Live Casino`,
    type: 'system',
  },
]
